import React, {useEffect} from "react";
import { useExtraData } from "./DataContext.js";

const BookCoverSize = () => {
    let { _source, isSchoolsUser } = useExtraData();

    let svgStyles = `.bookCover{fill:#007affcc;} .bookCaption{fill: #7a7a7a;}`;

    let height

    let getRescaleFactor = (bookHeight, bookWidth) => {
        
        let rescale, className;

        switch (true) {
            // Book within A5
            case bookHeight < 148 && bookWidth < 105:
                rescale = 141 / 148
                break;

            // Book within A3
            case bookHeight < 420 && bookWidth < 297:
                rescale = 141 / 420
                break;
        
            // Book within A1
            case bookHeight < 841 && bookWidth < 594:
                rescale = 141 / 841
                break;

            default:
                rescale = 141 / 874;
                break;
        }

        return rescale;
    };

    // Book page html
    useEffect(() => {

        if(isSchoolsUser){
            let bookSize = document.querySelector("#bookSize");
            let productDimensions = document.querySelector("#productDimensions");
            productDimensions.appendChild(bookSize);        
        }

        }, []
    );

    return (<>
        {(_source.width > 0 && _source.height > 0) && <div id="bookSize" className="bookSize" style={{height:"160px"}} title={`${_source.height}mm (h) x ${_source.width}mm (w)`}>
            <div className="bookSizeFrame">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 683 915" className="bookSizeSVG" style={{height:`${getRescaleFactor(_source.height, _source.width) * 894}px` }}>
                    <defs><style>{svgStyles}</style></defs>
                    <g id="scale">
                        <g id="A0_frame" dataname="A0 frame"><path d="M74,17H666V856H74V17m-1-1V857H667V16Z"/></g>
                        <text id="A0_label" dataname="A0 label" className="label" transform="translate(17 37.33)" style={{fontSize: `${12 / getRescaleFactor(_source.height, _source.width)}px`}}>A1</text>
                        <g id="A2_frame" dataname="A2 frame"><path d="M74,264H492V856H74V264m-1-1V857H493V263Z"/></g>
                        <text id="A2_label" dataname="A2 label" className="label" transform="translate(17.39 280.71)" style={{fontSize: `${12 / getRescaleFactor(_source.height, _source.width)}px`}}>A2</text>
                        <g id="A3_frame" dataname="A3 frame"><path d="M74,438H369V856H74V438m-1-1V857H370V437Z"/></g>
                        <text id="A3_label" dataname="A3 label" className="label" transform="translate(18.39 458.71)" style={{fontSize: `${12 / getRescaleFactor(_source.height, _source.width)}px`}}>A3</text>
                        <g id="A4_frame" dataname="A4 frame"><path d="M74,561H282V856H74V561m-1-1V857H283V560Z"/></g>
                        <text id="A4_label" dataname="A4 label" className="label" transform="translate(17.06 579.38)" style={{fontSize: `${12 / getRescaleFactor(_source.height, _source.width)}px`}}>A4</text>
                        <g id="A5_frame" dataname="A5 frame"><path d="M74,648H220V856H74V648m-1-1V857H221V647Z"/></g>
                        <text id="A5_label" dataname="A5 label" className="label" transform="translate(17.39 667.38)" style={{fontSize: `${12 / getRescaleFactor(_source.height, _source.width)}px`}}>A5</text>
                        <g id="A6_frame" dataname="A6 frame"><path d="M74,710H177V856H74V710m-1-1V857H178V709Z"/></g>
                        <text id="A6_label" dataname="A6 label" className="label" transform="translate(17.39 727.38)" style={{fontSize: `${12 / getRescaleFactor(_source.height, _source.width)}px`}}>A6</text>
                        {/* <g id="A7_frame" dataname="A7 frame"><path d="M74,753h72V856H74V753m-1-1V857h74V752Z"/></g>
                        <text id="A7_label" dataname="A7 label" className="label" transform="translate(17.39 771.38)">A7</text>
                        <g id="A8_frame" dataname="A8 frame"><path d="M74,784h50v72H74V784m-1-1v74h52V783Z"/></g>
                        <text id="A8_label" dataname="A8 label" className="label" transform="translate(18.06 804.38)">A8</text> */}
                    </g>
                    <g id="cover">
                        <rect id="bookCover" className="bookCover" x="74" y={870 - _source.height - 14} width={_source.width} height={_source.height}/>
                    </g>
                    <g id="caption">
                        <text id="bookCaption" className="bookCaption" transform="translate(75 900)">{`${_source.height}mm (h) x ${_source.width}mm (w)`}</text>
                    </g>
                </svg>
            </div>
        </div>}
    </>);
}

export default BookCoverSize;